export default __webpack_public_path__ + "static/media/header_3.8698a01c.jpg";